import React from "react";

export interface IWithDefaultEventsProps
{
	children?: React.ReactNode;
	onClick?: (e) => void;
	onMouseDown?: (e) => void;
	onContextMenu?: (e) => void;
	onDoubleClick?: (e) => void;
}

export default function WithDefaultEvents<T extends IWithDefaultEventsProps>(WrappedComponent: React.ComponentType<T>)
{
	return (props: T) => 
	{
		return (
			<WrappedComponent {...props} 
				onClick={createDefaultEventHandler("onClick")(props)}
				onMouseDown={createDefaultEventHandler("onMouseDown")(props)}
				onContextMenu={createDefaultEventHandler("onContextMenu")(props)}
				onDoubleClick={createDefaultEventHandler("onDoubleClick")(props)}
			/>
		);
	}
}

function createDefaultEventHandler(eventType: "onClick" | "onContextMenu" | "onDoubleClick" | "onMouseDown")
{
	return (props: any) => (e: React.MouseEvent) =>
	{
		if (props[eventType])
		{
			props[eventType](e);
			e.preventDefault();
			e.stopPropagation();
		}
	}
}